import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ComicCard from '@/components/base/ComicCard';
import { categories, comics } from '@/mocks/comics';
import { useState, useMemo } from 'react';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug) || categories[0];
  const [activeSlug, setActiveSlug] = useState(slug || 'romance');

  const filteredComics = useMemo(() => {
    return comics.filter((c) => c.category === activeSlug);
  }, [activeSlug]);

  const categoryJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${currentCategory.name} - 韩国漫画在线免费阅读`,
    description: currentCategory.description,
    url: `https://koreanmanhwa.com/category/${activeSlug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '韩国漫画网',
      url: 'https://koreanmanhwa.com/',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(categoryJsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: currentCategory.name },
              ]}
            />

            <div className="py-6">
              <h1 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
                {currentCategory.name}漫画
              </h1>
              <p className="text-sm text-foreground-500 mt-2">{currentCategory.description}</p>
            </div>

            <div className="flex flex-wrap items-center gap-1 mb-8 bg-background-100 rounded-full p-1">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  onClick={() => {
                    setActiveSlug(cat.slug);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap ${
                    activeSlug === cat.slug
                      ? 'bg-background-50 text-foreground-900 font-medium'
                      : 'text-foreground-500 hover:text-foreground-700'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {filteredComics.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5 pb-14">
                {filteredComics.map((comic) => (
                  <ComicCard key={comic.id} comic={comic} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500 text-sm">暂无该分类的漫画，敬请期待</p>
              </div>
            )}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}